import { Snippet } from '../snippet'

// TODO: this file is going to get huge, we need to split it up

// TODO: we need to figure out a better solution for sorting (these should
// appear in groups). Maybe have a concept of Snippet.Group?

export const FOR_DMS_QUERY: readonly Snippet[] = [
  /* -------------------------------- Model IDs ------------------------------- */
  // TODO: maybe only make these available in "target"
  new Snippet(({ range }) => ({
    detail: 'e.g., ent:!abc:!def',
    filterText: 'ent',
    insertText: 'ent:$1:$2',
    insertTextRules:
      monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
    kind: monaco.languages.CompletionItemKind.Constant,
    label: 'Entity ID',
    range,
  })),
  new Snippet(({ range }) => ({
    detail: 'e.g., snap:!abc:!def',
    filterText: 'snap',
    insertText: 'snap:$1:$2',
    insertTextRules:
      monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
    kind: monaco.languages.CompletionItemKind.Constant,
    label: 'Snapshot ID',
    range,
  })),

  /* ------------------------------ Full queries ------------------------------ */
  new Snippet(({ model, range }) =>
    // Only applies if the user has an empty editor
    monaco.Range.equalsRange(range, model.getFullModelRange())
      ? {
          detail: 'Produces an object',
          documentation:
            'Creates a DMS query with no `target` that produces an object',
          filterText: 'singleton',
          insertText: `{
  "selection": {
    "{}": {
      "\${1:property}": \${2:expression}
    }
  }
}`,
          insertTextRules:
            monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          kind: monaco.languages.CompletionItemKind.Struct,
          label: 'Singleton Query',
          range,
        }
      : undefined,
  ),

  new Snippet(({ model, range }) =>
    // Only applies if the user has an empty editor
    monaco.Range.equalsRange(range, model.getFullModelRange())
      ? {
          detail: 'Produces an object using subqueries',
          documentation:
            'Creates a DMS query with no `target` that produces an object and uses subqueries',
          filterText: 'singletonsubquery',
          insertText: `{
  "selection": {
    "{}": {
      "\${1:subqueryName}": { "@": "\${1:subqueryName}" }
    }
  },
  "subqueries": {
    "\${1:subqueryName}": {
      "target": "\${2:subqueryTarget}",
      "selection": {
        "\${3:fn}": \${4:arg}
      }
    }
  }
}`,
          insertTextRules:
            monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          kind: monaco.languages.CompletionItemKind.Struct,
          label: 'Singleton Query w/ Subquery',
          range,
        }
      : undefined,
  ),
]
